import PortalAuthPage from '@/pages/portal/PortalAuth.tsx'
import usePicFieldTitle from '@/hooks/usePicFieldTitle.ts'

/** Login for existing accounts. Signup lives on `/portal/demo`. */
export default function PortalLoginPage() {
  usePicFieldTitle('Anmelden')

  return <PortalAuthPage mode='login' />
}
